export function getFeatureType (featureId) {
  return this.getFeatureById(featureId).type
}
